import { useMemo } from "react";

const useOmittedNumber = (value: number): string => {
  const omittedNumber = useMemo(() => {
    if (value >= 1000) {
      return `${Math.floor(value / 1000)}K`;
    }

    return value + "";
  }, [value]);

  return omittedNumber;
};
export default useOmittedNumber;
